import { admitPatientAPI, dischargePatientAPI, getDiagnosisNamesAPI, updatePatientAPI } from "../adapter/cms-adapter"

export const admitPatient = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {
        admitPatientAPI(reqData).then((res) => {
            if (res && res.data && res.data.data) resolve(res);
            else reject("error occured in admit helper");
        })
    })
    return promise;
}

export const dischargePatient = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {
        dischargePatientAPI(reqData).then((res) => {
            if (res && res.data && res.data.data) resolve(res);
            else reject("error occured in discharge helper")
        })
    })
    return promise;
}

export const updatePatient = (data) => {
    let reqData = data;

    let promise = new Promise(function (resolve, reject) {
        updatePatientAPI(reqData).then((res) => {
            if (res && res.data && res.data.data) resolve(res);
            else reject("error occured in update helper")
        })
    })
    return promise;
}

export const getDiagnosisNamesHelper = (data) => {
    let reqData = data;
    let promise = new Promise((resolve, reject) => {
        return getDiagnosisNamesAPI(reqData).then((res) => {
            if (res && res.data && res.data.data) resolve(res.data.data);
            else reject("error in API request");
        }).catch((err) => {
            reject("error occurred in getDiagnosisNamesAPI", err);
        })

    })
    return promise;
}